//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
	computed: {
		...mapState({
			isLoading: state => state.isLoading
		})
	}
}



// WEBPACK FOOTER //
// ./src/components/modalLoad.vue